export const NOTIFICATION_ROUTES = {
	LIST: "/notifications",
} as const;
